/*
 * File: DashboardCard.js
 * Project: mp-mobile-app
 *
 * Created by brittni on 11/12/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description:
 */
/**
 * DashboardCard.js
 *
 * Component to render out count, label and icon for dashboard data
 */
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardContent } from "@material-ui/core";
import DashboardCardNumber from "./DashboardCardNumber";
import DashboardCardLabel from "./DashboardCardLabel";

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(1)
  },
  iconContainer: {
    display: "flex",
    padding: theme.spacing(1),
    flexDirection: "column",
    justifyContent: "center"
  },
  cardContent: {
    padding: 0,
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch",
    width: "100%",
    "&:last-child": {
      padding: 0
    }
  },
  iconPositioningContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    padding: "0.5em",
    background: theme.palette.common.buttonGradient,
    fontSize: "70%"
  },
  labelContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  expandingItem: {
    flex: "1 0"
  }
}));

const DashboardCard = ({ number, label, icon, url, loading }) => {
  const classes = useStyles();
  return (
    <Link to={url}>
      <Card className={classes.root}>
        <CardContent className={classes.cardContent}>
          <div className={classes.labelContainer}>
            <DashboardCardNumber loading={loading} number={number} />
          </div>
          <div className={classes.labelContainer + " " + classes.expandingItem}>
            <DashboardCardLabel label={label} />
          </div>
          {/* Create a div to center the icon vertically using flexbox */}
          <div className={classes.iconContainer}>
            {/* Create a div to wrap the icon, creating the background gradient and rounded corners. Use flexbox to center the icon along both axes */}
            <div className={classes.iconPositioningContainer}>{icon}</div>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
};

DashboardCard.propTypes = {
  number: PropTypes.number,
  label: PropTypes.string,
  icon: PropTypes.object,
  url: PropTypes.string,
  loading: PropTypes.bool
};

export default DashboardCard;
